<!-- (click) solution for mobile from https://github.com/angular/components/issues/12223#issuecomment-431998828  -->
<!-- and added $event.stopPropagation() in order to stop elements such as inputs, from being focused when user is only trying to see tooltip  -->
<fa-icon
  #tooltip="matTooltip"
  [icon]="['fas', 'info-circle']"
  [matTooltip]="text"
  [matTooltipTouchGestures]="'on'"
  [matTooltipClass]="'tooltip-medium-font'"
  (click)="tooltip.toggle(); $event.stopPropagation()"
  [matTooltipPosition]="tooltipPosition || 'below'"
></fa-icon>
